<template>
    <div class="container">
        <div style="position: absolute; right: 50px; bottom: 0px;">备案号：苏ICP备20010784号</div>
    </div>
</template>

<script>
/* eslint-disable */
export default {
    data() {
        return {
        }
    },
    mounted() {
    },
}
</script>

<style scoped>
.container {
    position: absolute;
    width: 100%;
    height: 100vh;
}
</style>
